const TYPE = `[MESSAGES]`;

const types = {
    FETCH_START: `${TYPE} FETCH START`,
    FETCH_SUCCESS: `${TYPE} FETCH SUCCESS`,
    FETCH_ERROR: `${TYPE} FETCH ERROR`,

    SEND_MESSAGE_START: `${TYPE} SEND MESSAGE START`,
    SEND_MESSAGE_SUCCESS: `${TYPE} SEND MESSAGE SUCCESS`,
    SEND_MESSAGE_ERROR: `${TYPE} SEND MESSAGE ERROR`,

    ADD_MESSAGE: `${TYPE} ADD MESSAGE`,

    SET_EXTRA_MESSAGES_TO_FETCH: `${TYPE} SET EXTRA MESSAGES TO FETCH`,

    CLEAR_CHAT: `${TYPE} CLEAR CHAT`,

    MARK_AS_READ_START: `${TYPE}  MARK AS READ START`,
    MARK_AS_READ_SUCCESS: `${TYPE}  MARK AS READ SUCCESS`,
    MARK_AS_READ_ERROR: `${TYPE}  MARK AS READ ERROR`,

    CLEAR_READ_LIST: `${TYPE} CLEAR READ_LIST`,

    RESET_ERROR: `${TYPE} RESET ERROR`,
}

export default types;